import { render, staticRenderFns } from "./loginOtp.vue?vue&type=template&id=2f0cc696&scoped=true&"
import script from "./loginOtp.vue?vue&type=script&lang=js&"
export * from "./loginOtp.vue?vue&type=script&lang=js&"
import style0 from "./loginOtp.vue?vue&type=style&index=0&id=2f0cc696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cc696",
  null
  
)

export default component.exports